import { Typography, TypographyProps } from '@mui/material';
import { ReactNode } from 'react';

import { Root } from './WidgetContent.styled';

export interface WidgetContentEmptyProps {
  title: ReactNode;
  color?: TypographyProps['color'];
}

export const WidgetContentEmpty = ({ title, color = 'grey.400', ...otherProps }: WidgetContentEmptyProps) => {
  return (
    <Root {...otherProps}>
      <Typography variant="overline" color={color}>
        {title}
      </Typography>
    </Root>
  );
};
